import { Controller } from "@hotwired/stimulus";

// Fades out and removes the element after a delay
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } };

  connect() {
    this.timer = setTimeout(() => this.dismiss(), this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  dismiss() {
    const el = this.element;
    el.style.maxHeight = `${el.offsetHeight}px`;
    el.style.overflow = "hidden";
    el.style.transition = "opacity 0.4s ease, max-height 0.4s ease 0.15s, margin 0.4s ease 0.15s";
    requestAnimationFrame(() => {
      el.style.opacity = "0";
      el.style.maxHeight = "0";
      el.style.marginBottom = "0";
    });
    setTimeout(() => el.remove(), 700);
  }
}
